module.exports = __webpack_public_path__ + "assets/img/solution4.a79b030e.png";